import { render, staticRenderFns } from "./SmsTickets.vue?vue&type=template&id=d9644c3a"
import script from "./SmsTickets.vue?vue&type=script&lang=js"
export * from "./SmsTickets.vue?vue&type=script&lang=js"
import style0 from "./SmsTickets.vue?vue&type=style&index=0&id=d9644c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports